import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { ConfirmSignIn } from "aws-amplify-react";
import { I18n, JS } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import AmplifyTheme from '../../themes/AmplifyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';


class CustomConfirmSignIn extends ConfirmSignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ['confirmSignIn'];
    this.confirm = this.confirm.bind(this);
    this.checkContact = this.checkContact.bind(this);
    this.state = {
        mfaType: 'SMS'
    };
  }

  checkContact(user) {
    if (!Auth || typeof Auth.verifiedContact !== 'function') {
        throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.verifiedContact(user)
    .then(data => {
        if (!JS.isEmpty(data.verified)) {
            this.changeState('signedIn', user);
        } else {
            const newUser = Object.assign(user, data);
            this.changeState('verifyContact', newUser);
        }
    });
  }

  confirm() {
    const user = this.props.authData;
    const { code } = this.inputs;
    const mfaType = user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'SOFTWARE_TOKEN_MFA' : null;
    if (!Auth || typeof Auth.confirmSignIn !== 'function') {
        throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }

    Auth.confirmSignIn(user, code, mfaType)
    .then(() => {
        this.checkContact(user);
    })
    .catch(err => this.error(err));
  }

  componentDidUpdate() {
    const user = this.props.authData;
    const mfaType = user && user.challengeName === 'SOFTWARE_TOKEN_MFA'?
        'TOTP' : 'SMS';
    if (this.state.mfaType !== mfaType) this.setState({ mfaType });
  }

  showComponent() {
    const { hide, classes } = this.props;
    if (hide && hide.includes(ConfirmSignIn)) { return null; }
    return (
      <MuiThemeProvider theme={AmplifyTheme}>
        <CssBaseline />
        <div className={classes.main}>
          <Paper className={classes.paper}>
            <img src={require('../../assets/img/logo-square-on-white.svg').default} width="200" height="200" alt="QRsticker logo"/>
            <Typography component="h1" variant="h5" className={classes.title}>
              {I18n.get('Confirm ' + this.state.mfaType + ' Code')}
            </Typography>
            <form className={classes.form}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="code">{I18n.get('Code')}</InputLabel>
                <Input id="code" key="code" name="code" autoComplete="code" autoFocus onChange={this.handleInputChange} />
              </FormControl>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="secondary"
                className={classes.submit}
                onClick={this.confirm}>
                  {I18n.get('Confirm')}
              </Button>
              <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={() => this.changeState('signIn')}>
                    {I18n.get('Back to Sign In')}
                </Button>
              </form>
          </Paper>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(AmplifyTheme)(CustomConfirmSignIn);